import { isDigitalDocumentSource, loadDigitalDocumentSource } from '../../utils/digitalDocumentSource';
import { attachmentOcrRequest, canReviewOcr } from '../../utils/attachmentOcr';
import { sourcePlainText } from '../../utils/sourceText';

export async function prepareCheckSources(items, retrieveFile) {
  const sources = await Promise.all((items || []).map(async item => {
    let text = '';
    if (canReviewOcr(item)) {
      const result = await attachmentOcrRequest('GET', item.path);
      if (result.status !== 'ready' || !result.reviewed_pages) {
        throw new Error(`OCR text for ${item.title} is still being prepared. Try Check Sources again when it finishes saving.`);
      }
      text = result.reviewed_pages.join('\n\n');
    } else if (isDigitalDocumentSource(item)) {
      text = (await loadDigitalDocumentSource(item, retrieveFile)).text;
    } else if (item.type === 'Consultation') {
      text = [item.originalData?.transcription, item.originalData?.notes]
        .map(value => sourcePlainText(value || '')).filter(Boolean).join('\n\n');
    } else if (item.type === 'Attachment') {
      throw new Error(`${item.title} cannot be checked as a source. Use DOCX, TXT, CSV, XLSX, PDF or images, or select its transcript.`);
    } else {
      text = sourcePlainText(item.originalData?.content || '');
    }
    return { id: item.id, title: item.title, text: text.trim() };
  }));
  const readable = sources.filter(source => source.text);
  if (!readable.length) throw new Error('The selected sources contain no text to check.');
  return {
    sources: readable,
    notes: readable.map(source => `Source: ${source.title}\n${source.text}`).join('\n\n'),
  };
}
